import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Select from 'admin/components/atoms/Select';

const optionToBool = opt => opt.value;


const ThreeStateSelect = ({
  trueLabel,
  falseLabel,
  unselectedLabel,
  value,
  setValue,
  className,
}) => {
  const unselectedOption = { value: null, label: unselectedLabel };
  const trueOption = { value: true, label: trueLabel };
  const falseOption = { value: false, label: falseLabel };
  const boolToOption = (b) => {
    switch (b) {
      case true:
        return trueOption;
      case false:
        return falseOption;
      default:
        return unselectedOption;
    }
  };
  const options = [
    unselectedOption,
    trueOption,
    falseOption,
  ];
  return (
    <Select
      className={className}
      options={options}
      value={boolToOption(value)}
      onChange={selectedValue => setValue(optionToBool(selectedValue))}
    />
  );
 };

ThreeStateSelect.propTypes = {
  trueLabel: PropTypes.string.isRequired,
  falseLabel: PropTypes.string.isRequired,
  unselectedLabel: PropTypes.string.isRequired,
  value: PropTypes.bool,
  setValue: PropTypes.func.isRequired,
  className: PropTypes.string,
};

ThreeStateSelect.defaultProps = {
  className: '',
};

export default styled(ThreeStateSelect)``;
